module.exports = __webpack_public_path__ + "static/media/css1.aa05f441.png";